import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearApiKeysState,
  generateApiKeyRequest,
  getApiKeyRequest,
} from '../store/apiKeys/apiKeys.action';
import {
  selectApiKey,
  selectFetchApiKeyError,
  selectFetchApiKeyLoading,
  selectFetchApiKeySuccess,
  selectGenerateApiKeyError,
  selectGenerateApiKeyLoading,
  selectGenerateApiKeySuccess,
  selectGeneratedKey,
} from '../store/apiKeys/apiKeys.selector';

export const useApiKeys = () => {
  const dispatch = useDispatch();

  // Selectors
  const apiKey = useSelector(selectApiKey);
  const generatedKey = useSelector(selectGeneratedKey);
  const generateLoading = useSelector(selectGenerateApiKeyLoading);
  const fetchLoading = useSelector(selectFetchApiKeyLoading);
  const generateError = useSelector(selectGenerateApiKeyError);
  const fetchError = useSelector(selectFetchApiKeyError);
  const generateSuccess = useSelector(selectGenerateApiKeySuccess);
  const fetchSuccess = useSelector(selectFetchApiKeySuccess);

  // Actions
  const generateApiKey = () => {
    dispatch(generateApiKeyRequest());
  };

  const fetchApiKey = useCallback(() => {
    dispatch(getApiKeyRequest());
  }, [dispatch]);

  const clearState = () => {
    dispatch(clearApiKeysState());
  };

  // Load API key on mount
  useEffect(() => {
    fetchApiKey();
  }, [fetchApiKey]);

  return {
    // Data
    apiKey,
    generatedKey,

    // Loading states
    generateLoading,
    fetchLoading,

    // Error states
    generateError,
    fetchError,

    // Success states
    generateSuccess,
    fetchSuccess,

    // Actions
    generateApiKey,
    fetchApiKey,
    clearState,
  };
};
